/**
 * ScenarioProjections - For regular Clerk-authenticated users
 * 
 * This is a thin wrapper around ScenarioProjectionsBase that handles
 * authentication via Clerk's useAuth hook.
 */

import React from 'react';
import { useAuth } from '../contexts/TestAuthContext';
import ScenarioProjectionsBase from './ScenarioProjectionsBase';

interface ScenarioProjectionsProps {
  reportId: string;
  baseResult: any;
}

export default function ScenarioProjections({ reportId, baseResult }: ScenarioProjectionsProps) {
  const { getToken } = useAuth();
  
  return (
    <ScenarioProjectionsBase
      reportId={reportId}
      baseResult={baseResult}
      getToken={getToken}
    />
  );
}
